export default __webpack_public_path__ + "static/media/anime_portrait.4cbee7ec.jpeg";